module.exports = __webpack_public_path__ + "img/dixie-coop.db3b7f89.jpg";